<template>
    <b-card class="accord" :class="`${level3 ? 'accord__level3' : ''} ${sub ? 'accord__sub' : ''} ${disabled ? 'accord_disabled' : ''}`" no-body>
        <div :class="`${variante ? `bg-gradient-${variante}` : 'sem_variante'} ${classTitulo}`" class="card__title d-flex justify-content-left align-items-center" v-b-toggle="`${disabled ? 'dont' : id}`" v-if="!hideTitle">
            <i v-if="sub" class="sub fa-solid fa-arrow-turn-up mr-3"></i>
            <span class="ml-2 title d-flex align-items-center">
                <slot name="prepend-title"/>
                <span>{{title}}</span>
                <slot name="append-title"/>
            </span>
        </div>
        <b-collapse :class="`${noBorderCollapse ? '' : 'accord__collapse'}`" :id="id" :accordion="accordion" :visible="hideTitle || visible">
            <slot></slot>
        </b-collapse>
    </b-card>
</template>
<script>
export default {
    props: {
        id: {
            required: true
        },
        title : {
            type: String,
            required: true
        },
        hideTitle: {
            type: Boolean,
            default: false
        },
        accordion: {
            type: String,
            default: 'accordion'
        },
        sub : {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            default: false
        },
        noBorderCollapse: {
            type: Boolean,
            default: false
        },
        level3: {
            type: Boolean,
            default: false
        },
        variante: {
            type: String,
        },
        classTitulo : {
            type: String,
            default: ''
        }
    },
    data : () => ({
        aberto: false
    }),
    watch: {
        visible : {
            handler(valor){
                this.aberto = valor;
            },
            immediate: true
        }
    },
    mounted(){
        this.$root.$on(
            'bv::collapse::state',
            (id, collapsed) => {
                if(id == this.id){
                    if(collapsed)
                        this.$emit('abriu', this.id);                   
                }
            }
        );
    }
}
</script>
<style>
    .accord{
        padding: 0 !important;
    }

    .accord__sub .card__title {        
        border-radius: 0;
        border-bottom: 1px solid #e5e5e5;
        
    }
    
    .accord__sub .card__title.sem_variante {
        background: #f5f5f5 !important;
        font-weight: inherit !important;
    }

    .accord__level3 .card__title {
        background: #FFF !important;
    }

    .accord__collapse {
        border-bottom: 1px solid #e5e5e5;
    }

    .title{
        padding-left: 10px;
    }

    .title::before{
        content: "\f067";
        font-family: 'Font Awesome 5 Free' !important;
        font-weight: 600;
        -webkit-transition: -webkit-transform .25s;
        transition: -webkit-transform .25s;
        transition: transform .25s;
        transition: transform .25s, -webkit-transform .25s;
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        color: #44a2d2;
        position: absolute;
        left: 10px;
    }

    .accord__sub .title::before{
        left: 35px;
    }

    .accord__sub .card__title .sub {
        color: #a7a7a7;
        -webkit-transform: rotate(-90deg);
        transform: rotate(90deg);
    }

    .collapsed > .title::before{
        content: "\f067";
        -webkit-transform: rotate(-90deg);
        transform: rotate(-90deg);
    }
    .not-collapsed > .title::before{
        content: "\f068";
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    .accord_disabled .card__title {
        color: #a9a9a9 !important;
    }

    .accord_disabled .card__title .title::before {
        content: "\f05e";
        color: #e97a7a;
        transform: rotate(0deg) !important;
    }

    .accord__sub {
        box-shadow: none !important;
    }

</style>